<template>
  <div class="loans-pro-item">
    <p class="title">{{ safeItem.title }}</p>
    <p class="desc">
      {{ $t("loans.Institution") }} : {{ safeItem.mechanism }}
    </p>
    <p class="desc">{{ $t("loans.Amount") }} : {{ safeItem.minprice }} - {{ safeItem.maxprice }}</p>
    <p class="desc">{{ $t("loans.DailyInterest") }} : {{ safeItem.interest_rate }} %</p>
    <p class="desc">
      {{ $t("loans.RepaymentPeriod") }} : {{ safeItem.cycle }} {{ $t("common.day") }}
    </p>
    <div style="display: none;width: 50%; margin: 15px 0">
      <van-progress :percentage="50" color="#02c289" />
    </div>
    <van-button size="small" class="web-btn-rise loans-application" @click="toApplication(safeItem.id)">{{
      $t("loans.Application")
    }}</van-button>
  </div>
</template>

<script>
export default {
  name: "LoanPro",
  props: ['item'],
  computed:{
    safeItem(){
      return this.item || {}
    }
  },
  methods:{
    toApplication(id){
        this.$router.push(
        {
          name: "loans-application",
          query: {
            id: id
          },
        },
        () => {}
      );
    },
    
  }
};
</script>

<style>
</style>

